import { useQuery } from '@tanstack/react-query'

import { useQueryErrorAlert } from '@hooks/useQueryErrorAlert'

import { useAuthenticatedUser } from '../../../auth/hooks/useAuthenticatedUser'
import { fetchContracten, initialState } from '../services/fetchContracten'
import type { ContractinstellingenSearchFilters } from '../types/ContractinstellingenSearch'

export { useContractenSearch }

const queryKey = 'aanvraag-contracten'

const useContractenSearch = ({
  externalFilters: filters,
}: {
  externalFilters: ContractinstellingenSearchFilters
}) => {
  const { hasPermissions } = useAuthenticatedUser()

  const {
    data,
    isFetching: isLoading,
    error,
    errorUpdatedAt,
  } = useQuery({
    queryKey: [queryKey, filters],
    queryFn: () => fetchContracten(filters),
    enabled: hasPermissions && !!filters.combi,
  })

  useQueryErrorAlert(error, errorUpdatedAt, 'Fout bij ophalen van contracten')

  return {
    data: data || initialState.data,
    isLoading,
    error,
  }
}
